<template>
  <div class="container__method-components-sidebar">
    <b-button v-b-toggle.sidebar-backdrop variant="primary" class="button__open-sidebar">
      <font-awesome-icon :icon="{ prefix: 'fa', iconName: 'bars' }" />
    </b-button>
    <!-- <b-button
      ref="btn__previous-page"
      variant="link"
      class="btn__previous-page back-button"
      @click="backToMethodComponents"
    >
      <font-awesome-icon icon="chevron-left" class="mx-u2" />

      <span>Back to Method Components</span>
    </b-button> -->

    <b-sidebar
      id="sidebar-backdrop"
      ref="sidebar"
      class="sidebar__method-components"
      backdrop
      width="380"
      :class="mode === 'create' ? 'sidebar__as-owner' : 'sidebar__as-learner'"
    >
      <template #header>
        <div class="b-sidebar-header-content">
          <b-button v-b-toggle.sidebar-backdrop variant="primary">
            <font-awesome-icon :icon="{ prefix: 'fa', iconName: 'bars' }" />
          </b-button>
          <b-button
            ref="btn__previous-page"
            variant="link"
            class="btn__previous-page back-button"
            @click="backToMethodComponents"
          >
            <font-awesome-icon icon="chevron-left" class="mr-u1" />

            <span>Back to Method Components</span>
          </b-button>
        </div>
      </template>
      <template #default>
        <slot></slot>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronLeft);

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },

  props: {
    mode: {
      type: String,
      required: true,
      validator: (value) => ['create', 'view'].includes(value)
    }
  },
  methods: {
    backToMethodComponents() {
      this.$router.push({
        name: 'learning-unit/method-components'
      });
      this.$emit('back-to-method-components');
    },

    closeSidebar() {
      // Close the Bootstrap Vue sidebar using ref
      if (this.$refs.sidebar) {
        this.$refs.sidebar.hide();
      }
    }
  }
};
</script>

<style lang="scss">
.container__method-components-sidebar {
  --sidebar-bg-color-default: #ffffff;
  --sidebar-bg-color-learner: #eceef7;
  --sidebar-bg-backdrop: #00000052;
  --primary-dark: #3b3e66;

  .b-sidebar {
    width: 309px;
  }

  .b-sidebar-header {
    padding: 20px;
  }

  .b-sidebar-header,
  .b-sidebar-body {
    color: var(--primary-dark);
    background-color: var(--sidebar-bg-color-default);
  }

  .sidebar__as-owner {
    .b-sidebar-header {
      padding: 20px 20px 0 20px;
    }
    .b-sidebar-body {
      padding: 20px;
    }
  }
  .sidebar__as-learner {
    .b-sidebar-header,
    .b-sidebar-body {
      background-color: var(--sidebar-bg-color-learner);
    }
    .b-sidebar-header {
      padding: 20px 20px 0 20px;
    }
  }

  .button__open-sidebar {
    width: max-content;
  }

  @media screen and (min-width: 376px) {
    .b-sidebar {
      width: 347px;
      background-color: #3b3e66;
    }
  }
}
.b-sidebar-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.back-button {
  width: max-content;
  font-weight: 400;
  font-size: 16px;
  padding: 12px 6px;
}

@media screen and (max-width: 575px) {
  b-sidebar {
    width: 3009px;
    background-color: #a76262;
  }
}
</style>
